<template>
  <div class="columns is-multiline mgb-3">
    <div class="column is-12">
      <libelle-tag-input
        v-model="produitsIndexable"
        :items="categorieProduitIndexation"
        :disabled="true"
        :label="$t('detailCommande.indexation.popUp.typesProduits')">
      </libelle-tag-input>
    </div>
    <div class="column is-6">
      <indexation-valeur
        :label="$t('detailCommande.indexation.popUp.informationReference')"
        :date="dateReference"
        :valeur="valeurReference"
        :disabled="true"
        :indiceSelected="indiceSelected"/>
    </div>
    <div class="column is-6">
      <indexation-valeur
        :label="$t('detailCommande.indexation.popUp.informationActuel')"
        :date.sync="payload.dateIndexationActuel"
        :valeur.sync="payload.valeurIndexationActuel"
        :indiceSelected="indiceSelected"
        @valuechanges="calculPourcentageTheorique"/>
    </div>
    <div class="column is-4">
      <b-field :label="$t('detailCommande.indexation.popUp.pourcentageTheorique')">
        <input-currency
          v-model="pourcentageTheorique"
          disabled isNumber>
        </input-currency>
      </b-field>
    </div>
    <div class="column is-4">
      <b-field :label="$t('detailCommande.indexation.popUp.pourcentageReel')">
        <input-currency
          v-model="payload.pourcentageReel"
          isNumber>
        </input-currency>
      </b-field>
    </div>
    <div class="column is-4">
      <b-field :label="$t('detailCommande.indexation.popUp.dateIndexation')">
        <b-datepicker
          v-model="payload.dateIndexation"
          icon="calendar-today"
          position="is-bottom-right"
          nearby-selectable-month-days
          show-week-number
          editable />
      </b-field>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { CATEGORIE_PRODUIT_INDEXABLE } from '@/configuration/catalogue/produitConf';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';
import inputCurrency from '@/components/general/inputCurrency';
import calculArrondi from '@/services/calcul/calculArrondi';
import indexationValeur from '@/components/baux/contrat/componentEdition/indexationValeur';

const Societe = createNamespacedHelpers('societe');

export default {
  props: {
    commande: {
      type: Object,
      required: true,
    },
    payload: {
      type: Object,
      required: true,
    },
    indiceEtValeurs: {
      type: Array,
      default: () => ([]),
    },
  },
  components: {
    libelleTagInput,
    inputCurrency,
    indexationValeur,
  },
  data() {
    return {
      pourcentageTheorique: 0,
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
    categorieProduitIndexation() {
      return this.societeActive.produitsIndexable.map(c => {
        return CATEGORIE_PRODUIT_INDEXABLE.find(p => p.code === c);
      });
    },
    produitsIndexable: {
      get() {
        return this.categorieProduitIndexation
          .filter(c => this.payload.typesProduits
            .includes(c.code));
      },
      set(val) {
        this.payload.typesProduits = val.map(c => c.code);
      },
    },
    dateReference() {
      if (this.commande.valeurIndexationActuel) {
        return new Date(this.commande.dateIndexationActuel);
      }
      return new Date(this.commande.dateIndexationReference);
    },
    valeurReference() {
      if (this.commande.valeurIndexationActuel) {
        return this.commande.valeurIndexationActuel;
      }
      return this.commande.valeurIndexationReference;
    },
    indiceSelected() {
      return this.indiceEtValeurs.find(el => el.id === this.commande.indiceReferenceId);
    },
  },
  methods: {
    calculPourcentageTheorique() {
      const rapport = this.payload.valeurIndexationActuel / this.valeurReference;
      const mantisse = this.societeActive.mantisse;
      if (mantisse) {
        this.pourcentageTheorique = calculArrondi((rapport * 100) - 100, mantisse);
      } else {
        this.pourcentageTheorique = (rapport * 100) - 100;
      }
      this.payload.pourcentageReel = this.pourcentageTheorique;
      this.payload.dateIndexation = this.payload.dateIndexationActuel;
    },
  },
  mounted() {
    this.calculPourcentageTheorique();
  },
};
</script>
